import Axios from "../../Config/API";
import {
    IEmpresa,
    IObra,
    IObraEmpresa,
} from "../../../Interfaces/Cobranca/Obras/ObrasInterfaces";
import Service from "../../Service";

export async function ListarObrasService() {
    return Service(Axios.get<Array<IObra>>(`/cobranca/obras/listarobras`));
}

export async function GetObraService(idCasoCobrancaObra: number) {
    return Service(
        Axios.get<IObra>(
            `/cobranca/obras/getobras?idCasoCobrancaObra=${idCasoCobrancaObra}`
        )
    );
}

export async function AtualizarObraService(requestBody: IObra) {
    return Service(Axios.put(`/cobranca/obras/atualizarobra`, requestBody));
}

export async function DeletarObraService(idCasoCobrancaObra: number) {
    return Service(
        Axios.delete(
            `/cobranca/obras/deletarobra?idCasoCobrancaObra=${idCasoCobrancaObra}`
        )
    );
}

export async function CadastrarObraService(requestBody: IObra) {
    return Service(Axios.post(`/cobranca/obras/cadastrarobra`, requestBody));
}

export async function ConsultarEmpresaService() {
    return Service(
        Axios.get<Array<IEmpresa>>(`/cobranca/obras/consultarempresa`)
    );
}

export async function ConsultarObraService(IdEmpresa: number) {
    return Service(
        Axios.get<Array<IObraEmpresa>>(
            `/cobranca/obras/consultarobra?IdEmpresa=${IdEmpresa}`
        )
    );
}
